export interface IConsentItem {
    consent_template_id: string;
    state: boolean;
}

export enum FinancialApplicationSource {
    GHF_CONTACT = 1,
    GHF_REFINANCE = 2,
    RP_INSTALLMENT_CALCULATOR = 3,
    RP_CREDITWORTHINESS_CALCULATOR = 4
}

export const FINANCIAL_APPLICATION_SOURCE_RP_LABEL = {
    [FinancialApplicationSource.RP_INSTALLMENT_CALCULATOR]: "Kalkulator raty RP",
    [FinancialApplicationSource.RP_CREDITWORTHINESS_CALCULATOR]: "Kalkulator zdolności RP"
} as const;

export enum ServiceType {
    MORTGAGE = 1,
    REFINANCE = 2
}

export interface ICreateFinancialApplicationRequest {
    name: string;
    email: string;
    phone: string;
    meta: {
        author: string;
        frontend_version: string;
    };
    consents: IConsentItem[];
    source: FinancialApplicationSource;
    service_type: ServiceType;
    text: string;
    turnstile_token?: string;
    action?: string;
}
export interface IConsentItem {
    consent_template_id: string;
    state: boolean;
}

export enum FinancialApplicationSource {
    GHF_CONTACT = 1,
    GHF_REFINANCE = 2,
    RP_INSTALLMENT_CALCULATOR = 3,
    RP_CREDITWORTHINESS_CALCULATOR = 4
}

export const FINANCIAL_APPLICATION_SOURCE_RP_LABEL = {
    [FinancialApplicationSource.RP_INSTALLMENT_CALCULATOR]: "Kalkulator raty RP",
    [FinancialApplicationSource.RP_CREDITWORTHINESS_CALCULATOR]: "Kalkulator zdolności RP"
} as const;

export enum ServiceType {
    MORTGAGE = 1,
    REFINANCE = 2
}

export interface ICreateFinancialApplicationRequest {
    name: string;
    email: string;
    phone: string;
    meta: {
        author: string;
        frontend_version: string;
    };
    consents: IConsentItem[];
    source: FinancialApplicationSource;
    service_type: ServiceType;
    text: string;
    turnstile_token?: string;
    action?: string;
}
